module.exports = __webpack_public_path__ + "img/leaf-icon.90d663c8.png";